export class ServiceStatisticSummaryResponseEntity {
  date?: string
  numberOfOrders?: number
  numberOfCanceledOrders?: number
  numberOfDeliveredOrders?: number
  numberOfNotDeliveredOrders?: number
  numberOfDeliveryTimeOrders?: number
}
